/** Kerio Connect FilterRule AST (Client API FiltersCommon). */
export function emptyKerioRule() {
    return {
        isEnabled: true,
        description: "New rule",
        isIncomplete: false,
        conditions: [
            {
                testedTarget: "CtSubject",
                comparator: "CcContain",
                parameters: [""],
            },
        ],
        actions: [{ type: "FaFileInto", parameters: ["INBOX"] }],
        evaluationMode: "EmAllOf",
    };
}
export function cloneRules(rules) {
    return structuredClone(rules);
}
